import React from "react"

import ProductsPage from "./products"

const IndexPage = () => <ProductsPage />

export default IndexPage
